import serverOptimized from '@nykaa/nes-utils/serverOptimized';


export default serverOptimized(() => import(/* webpackChunkName: "Wishlist.m" */'./Loadable'), '');
